import { FC, useEffect } from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'
import AddButton from '@organisms/AddButton'
import { BlockWrapper, AddButtonWrapper, ErrorText, StyledTitle } from './styled'
import CourseAvailabilityRow from './Row'

const EMPTY_ROW = { company: null, filial: null }

const CourseAvailabilityBlock: FC = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext()

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'courseAvailabilities',
  })

  useEffect(() => {
    if (fields.length === 0) {
      append(EMPTY_ROW)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const errorMessage = (errors.courseAvailabilities as { message?: string } | undefined)
    ?.message

  return (
    <BlockWrapper>
      <StyledTitle>Доступность курса</StyledTitle>
      {fields.map((field, index) => (
        <CourseAvailabilityRow
          key={field.id}
          index={index}
          onRemove={() => remove(index)}
        />
      ))}
      {errorMessage && <ErrorText>{errorMessage}</ErrorText>}
      <AddButtonWrapper>
        <AddButton
          type="button"
          onClick={() => append(EMPTY_ROW)}
        >
          Добавить
        </AddButton>
      </AddButtonWrapper>
    </BlockWrapper>
  )
}

export default CourseAvailabilityBlock
